import { render, staticRenderFns } from "./ReqImagePreview.vue?vue&type=template&id=0fe822f8"
import script from "./ReqImagePreview.vue?vue&type=script&lang=js"
export * from "./ReqImagePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports